export const DraggableTypes = {
  SET: 'set',
  EXERCISE: 'exercise',
  WORKOUT: 'workout'
};